module.exports = __webpack_public_path__ + "img/gw.274444b6.svg";